import {
  RESET_HIGHLIGHTED_MENU,
  UPDATE_NAVIGATION_MENU
} from "../actions/navigationMenuActions";

let initialState = {
  highlightedMenu: undefined,
  menuItems: [],
  selectedMenu: null,
  isHamburgerMenuOpen: false
};

export default (state = initialState, action) => {
  if (action) {
    if (action.type === RESET_HIGHLIGHTED_MENU) {
      return {
        ...state,
        highlightedMenu: undefined
      };
    } else if (action.type === UPDATE_NAVIGATION_MENU) {
      return {
        ...state,
        ...action.payload
      };
    }
  }

  return state;
};
